import { UsePatronLocationState, usePatronLocationState } from 'hooks/usePatronLocationState';
import { isEmptyChildren } from 'utils/isEmptyChildren';
import { isFunction } from 'es-toolkit/compat';
import React, { FunctionComponent } from 'react';

export const PatronLocationStateContext = React.createContext<UsePatronLocationState>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  undefined as any
);

export const PatronLocationContext: FunctionComponent = ({ children }) => {
  const patronLocationState = usePatronLocationState();
  return (
    <PatronLocationStateContext.Provider value={patronLocationState}>
      {children
        ? isFunction(children)
          ? (children as (patronLocationState: UsePatronLocationState) => React.ReactNode)(
              patronLocationState as UsePatronLocationState
            )
          : !isEmptyChildren(children)
            ? React.Children.only(children)
            : null
        : null}
    </PatronLocationStateContext.Provider>
  );
};
